import {useSelector} from 'react-redux';

import {selectCurrentUserInfo} from '@dms/api/customer';

const MANAGER_ROLE_TITLE = 'MANAGER';

export function useCanToggleOtherUserAway() {
  const currentUserInfo = useSelector(selectCurrentUserInfo);

  return currentUserInfo.data?.roles?.some((role) => role.title === MANAGER_ROLE_TITLE) ?? false;
}
